var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgDesplegartexto = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0,0h24v24H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9E3F4",
    d: "M12,2C6.48,2,2,6.48,2,12c0,5.52,4.48,10,10,10c5.52,0,10-4.48,10-10C22,6.48,17.52,2,12,2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00A3DA",
    d: "M15.875,10.457l-3.879,3.88l-3.88-3.88c-0.39-0.39-1.021-0.39-1.41,0c-0.39,0.39-0.39,1.021,0,1.41 l4.59,4.59c0.39,0.39,1.021,0.39,1.41,0l4.59-4.59c0.391-0.39,0.391-1.021,0-1.41C16.906,10.077,16.266,10.067,15.875,10.457z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    display: "none",
    fill: "#00A3DA",
    d: "M16,13h-3v3c0,0.55-0.45,1-1,1s-1-0.45-1-1v-3H8c-0.55,0-1-0.45-1-1s0.45-1,1-1h3V8 c0-0.55,0.45-1,1-1s1,0.45,1,1v3h3c0.55,0,1,0.45,1,1S16.55,13,16,13z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDesplegartexto, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/desplegar texto.c5287863.svg";
export { ForwardRef as ReactComponent };